import { formatCurrencyToScaleTruncated } from '@/utilities/portfolio/formatValue';
import { formatterPercentage } from '@/utilities/format';
import type {
  DividendHoldingItem,
  Period,
} from '@/features/portfolio/types/portfolioDividend';

type ScoreCategory = 'bad' | 'warning' | 'good';

export const categorizeScore = (score: number): ScoreCategory => {
  if (score <= 2) {
    return 'bad';
  }
  if (score <= 4) {
    return 'warning';
  }
  return 'good';
};

export const getFormattedValues = (
  holding: DividendHoldingItem,
  currencyISO: string
) => {
  const payment = formatCurrencyToScaleTruncated(holding.payment, currencyISO);
  const contribution = formatterPercentage(holding.contribution);
  const dividendYield = formatterPercentage(holding.dividendYield);
  const yieldOnCost = formatterPercentage(holding.yieldOnCapitalInvested);
  const dividendScore = holding.dividendScore;
  const dividendGrowth = formatterPercentage(
    holding.dividendPaymentsGrowthAnnual
  );

  return {
    payment,
    contribution,
    dividendYield,
    yieldOnCost,
    dividendScore,
    dividendGrowth,
  };
};

const PERIOD_MAP: Record<Period, string> = {
  last1y: 'Last 1y',
  next1y: '+12m',
  next2y: '+2y',
  next3y: '+3y',
};

export const getHeaders = (period: Period) => {
  return [
    'Symbol',
    `${PERIOD_MAP[period]} Payment \n& Contribution`,
    'Yield vs \nYield on Cost',
    'Dividend Score \n& Growth',
  ];
};
